/* ==========================================================================
   SMOON — Landing « Pink Mania »
   Onglets flux, carrousels, sélecteurs de variante, ajout panier AJAX,
   guide des tailles, lightbox, FAQ et apparitions au scroll.
   Vanilla, sans dépendance, idempotent (sûr avec l'éditeur de thème).
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.pm[data-pm-root]';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var f = window.Shopify && window.Shopify.money_format;
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (f && f.indexOf('{{') > -1) {
      return f.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return v + ' €';
  }

  /* ------------------------------------------------------------ carrousels
     Piste en scroll-snap : le défilement reste natif (fluide et accessible
     au swipe), le JS ne pilote que les flèches et les points. */
  function initSlider(vp) {
    if (vp.dataset.pmSlider) return;
    vp.dataset.pmSlider = '1';

    /* la piste est l'élément lui-même s'il la porte, sinon on descend — mais
       jamais dans un slider imbriqué (un rail de cartes n'est pas la galerie
       d'une de ses cartes) */
    var track = vp.matches('[data-pm-track]') ? vp : null;
    if (!track) {
      var cands = vp.querySelectorAll('[data-pm-track]');
      for (var c = 0; c < cands.length; c++) {
        var owner = cands[c].closest('[data-pm-slider]');
        if (!owner || owner === vp) { track = cands[c]; break; }
      }
    }
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function scroller() {
      return track.scrollWidth > track.clientWidth + 1 ? track : vp;
    }

    /* les contrôles peuvent vivre dans la piste, à côté, ou plus haut */
    function ctrl(sel) {
      var scopes = [vp, vp.parentElement, vp.parentElement && vp.parentElement.parentElement, vp.closest('section')];
      for (var i = 0; i < scopes.length; i++) {
        if (!scopes[i]) continue;
        var els = scopes[i].querySelectorAll(sel);
        for (var j = 0; j < els.length; j++) {
          var own = els[j].closest('[data-pm-slider]');
          if (own && own !== vp) continue;
          return els[j];
        }
      }
      return null;
    }

    var dotsBox = ctrl('[data-pm-dots]');
    var prev = ctrl('[data-pm-prev]');
    var next = ctrl('[data-pm-next]');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.children) : [];

    function step() {
      return slides.length > 1 ? Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft) : 1;
    }

    function current() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(scroller().scrollLeft / step())));
    }

    function paint(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var sc = scroller();
      var none = sc.scrollWidth <= sc.clientWidth + 2;
      if (prev) prev.disabled = none || sc.scrollLeft <= 2;
      if (next) next.disabled = none || sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 2;
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      scroller().scrollTo({ left: i * step(), behavior: smooth === false ? 'auto' : 'smooth' });
      paint(i);
    }

    vp.pmGoTo = goTo;

    var raf;
    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(current()); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    if (vp !== track) vp.addEventListener('scroll', onScroll, { passive: true });

    function page(dir) {
      var sc = scroller();
      var per = Math.max(1, Math.round(sc.clientWidth / step()));
      goTo(current() + dir * per);
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });

    paint(0);
    window.addEventListener('resize', function () { paint(current()); }, { passive: true });
  }

  /* -------------------------------------------------------------- onglets */
  function initTabs(root) {
    $$('[data-pm-tabs]', root).forEach(function (group) {
      if (group.dataset.pmInit) return;
      group.dataset.pmInit = '1';
      var tabs = $$('[data-pm-pane]', group);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) {
            x.classList.remove('is-on');
            x.setAttribute('aria-selected', 'false');
            var p = root.querySelector('#' + x.dataset.pmPane);
            if (p) p.classList.remove('is-on');
          });
          t.classList.add('is-on');
          t.setAttribute('aria-selected', 'true');
          var pane = root.querySelector('#' + t.dataset.pmPane);
          if (pane) {
            pane.classList.add('is-on');
            /* les rails du panneau étaient masqués : leurs mesures sont à refaire */
            requestAnimationFrame(function () {
              $$('[data-pm-slider]', pane).forEach(function (s) {
                if (s.pmGoTo) s.pmGoTo(0, false);
              });
            });
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------ FAQ */
  function initFaq(root) {
    $$('[data-pm-faq]', root).forEach(function (item) {
      if (item.dataset.pmInit) return;
      item.dataset.pmInit = '1';
      var q = item.querySelector('[data-pm-faq-q]');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------------- variantes + panier */
  function initProductForm(scope) {
    if (scope.dataset.pmForm) return;
    scope.dataset.pmForm = '1';

    var dataEl = scope.querySelector('[data-pm-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = scope.querySelector('[data-pm-variant]');
    var input = scope.querySelector('[data-pm-id]');
    var btn = scope.querySelector('[data-pm-add]');
    var lbl = btn ? btn.querySelector('[data-pm-lbl]') : null;
    var priceEl = scope.querySelector('[data-pm-price]');
    var wasEl = scope.querySelector('[data-pm-was]');

    var gallery = scope.querySelector('[data-pm-slider]');
    if (!gallery) {
      var host = scope.closest('section') || scope.parentElement;
      gallery = host ? host.querySelector('[data-pm-slider]') : null;
    }

    function variantById(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    var booted = false;

    function sync() {
      var v = variantById(select ? select.value : (input && input.value));
      if (!v) return;
      if (input) input.value = v.id;

      if (booted && gallery && gallery.pmGoTo && data.leadIdx) {
        var idx = data.leadIdx[String(v.id)];
        if (typeof idx === 'number') gallery.pmGoTo(idx);
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare > v.price) { wasEl.textContent = money(v.compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (btn) {
        btn.disabled = !v.available;
        if (lbl) lbl.textContent = v.available ? (data.labelAdd || '') : (data.labelOut || '');
      }
    }

    if (select) select.addEventListener('change', sync);
    sync();
    booted = true;

    var form = scope.querySelector('[data-pm-cart-form]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-load')) return;
      btn.classList.add('is-load');

      var body = new FormData(form);
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.location.href = form.action; return; }
          if (drawer) {
            if (drawer.classList && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer.renderContents) drawer.renderContents(res);
            if (drawer.open) drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { window.location.href = form.action; })
        .finally(function () { btn.classList.remove('is-load'); });
    });
  }

  /* ------------------------------------------------- guide des tailles */
  function initGuide(root) {
    var panel = document.querySelector('.pm-sg');
    if (!panel) return;
    var opener = null;

    function open(from) {
      opener = from || null;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      var c = panel.querySelector('.pm-sg__close');
      if (c) c.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      panel.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    $$('[data-pm-guide]', root).forEach(function (link) {
      if (link.dataset.pmInit) return;
      link.dataset.pmInit = '1';
      link.addEventListener('click', function (e) { e.preventDefault(); open(link); });
    });

    if (!panel.dataset.pmInit) {
      panel.dataset.pmInit = '1';
      $$('[data-pm-sg-close]', panel).forEach(function (el) { el.addEventListener('click', close); });
    }
  }

  /* ------------------------------------------------------------- lightbox */
  function initLightbox(root) {
    var lb = document.querySelector('.pm-lb');
    if (!lb) return;

    var imgEl = lb.querySelector('[data-pm-lb-img]');
    var stage = lb.querySelector('[data-pm-lb-stage]');
    var countEl = lb.querySelector('[data-pm-lb-count]');
    var prevBtn = lb.querySelector('[data-pm-lb-prev]');
    var nextBtn = lb.querySelector('[data-pm-lb-next]');
    var group = [];
    var pos = 0;
    var opener = null;

    function render() {
      var s = group[pos];
      if (!s) return;
      imgEl.src = s.full;
      imgEl.alt = s.alt || '';
      if (s.w && s.h) { imgEl.width = s.w; imgEl.height = s.h; }
      var multi = group.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      countEl.textContent = multi ? (pos + 1) + ' / ' + group.length : '';
    }

    function open(list, i, from) {
      group = list; pos = i; opener = from || null;
      render();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      lb.querySelector('.pm-lb__close').focus();
    }

    function close() {
      lb.hidden = true;
      imgEl.removeAttribute('src');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }

    function move(d) {
      if (group.length < 2) return;
      pos = (pos + d + group.length) % group.length;
      render();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') move(-1);
      else if (e.key === 'ArrowRight') move(1);
    }

    if (!lb.dataset.pmInit) {
      lb.dataset.pmInit = '1';
      lb.querySelector('[data-pm-lb-close]').addEventListener('click', close);
      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); move(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); move(1); });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.pm-lb__nav, .pm-lb__close')) return;
        if (e.target === imgEl) return;
        close();
      });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) move(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    function toItem(i) {
      return {
        full: (i.currentSrc || i.src).replace(/([?&])width=\d+/, '$1width=1600'),
        alt: i.alt,
        w: i.naturalWidth || i.width,
        h: i.naturalHeight || i.height
      };
    }

    /* chaque piste d'images devient un groupe navigable */
    $$('[data-pm-track]', root).forEach(function (track) {
      $$('img', track).forEach(function (img) {
        if (img.dataset.pmLb) return;
        img.dataset.pmLb = '1';
        img.addEventListener('click', function () {
          var imgs = $$('img', track);
          open(imgs.map(toItem), imgs.indexOf(img), img);
        });
      });
    });

    /* images isolées explicitement marquées */
    $$('.pm-zoom', root).forEach(function (img) {
      if (img.dataset.pmLb) return;
      img.dataset.pmLb = '1';
      img.addEventListener('click', function () { open([toItem(img)], 0, img); });
    });
  }

  /* --------------------------------------------------------------- ancres */
  function initAnchors(root) {
    $$('[data-pm-scroll]', root).forEach(function (a) {
      if (a.dataset.pmInit) return;
      a.dataset.pmInit = '1';
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.dataset.pmScroll);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
        var offset = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------- apparitions */
  function initReveal(root) {
    var els = $$('.pm-anim', root).filter(function (el) { return !el.dataset.pmSeen; });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.dataset.pmSeen = '1'; io.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */
  function boot(root) {
    if (!root) return;
    $$('[data-pm-slider]', root).forEach(initSlider);
    $$('[data-pm-product]', root).forEach(initProductForm);
    initTabs(root);
    initFaq(root);
    initGuide(root);
    initLightbox(root);
    initAnchors(root);
    initReveal(root);
  }

  function bootAll() { $$(SEL).forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SEL) || (e.target.matches && e.target.matches(SEL) ? e.target : null);
    boot(root);
  });
})();
